import React, { Component } from 'react'

import { Tabs } from 'antd';
// import founderImg from '../../images/feng_web.svg'
import './index.css'
const TabPane = Tabs.TabPane;

export default class CompanyIntro extends Component {
  render() {
    return (
      <div id='about'>
        <div className='tabWrap'>
          <Tabs defaultActiveKey="1">
            {/* <TabPane tab="创始人介绍" key="1">
              <div className='founder'>
                <div className='founderImgWrap'>
                  <div className='circle'><img src={founderImg} alt=''/></div>
                  <p className='name'>冯涛</p>
                  <p className='company'>嘉云升科技创始人 CEO</p>
                  <p className='job'>曾任嘉宝仁和CEO，联合创始人</p>
                  <p className='job'>Creative Genomics (NY, USA) 联合创始人</p>
                  <p className='job'>华大基因生物信息分析师</p>
                  <p className='job'>毕业于北京大学生命科学学院</p>
                  <p className='job'>北京大学国家发展研究院MBA</p>
                </div>
              </div>
            </TabPane> */}
            <TabPane tab="公司介绍" key="1">
              <div className='companyIntro'>
                <div className='companyWrap'>
                  <div className='companyItem'>
                    <div className='title'>团队</div>
                    <div className='itemContent'>嘉云升创始团队由具有丰富经验的医学科学家、产品专家、技术专家、数据专家组成。我们对医疗服务、企业级应用、互联网产业的整合具有独特的洞察与丰富的经验，我们在产品中使用最为前沿的科技以保障对医护工作、研究工作等专业人士在效率和交互体验等多方面的提升</div>
                  </div>
                  <div className='companyItem'>
                    <div className='title'>专业</div>
                    <div className='itemContent'>医疗是一个进入壁垒高、知识门槛高的领域，我们在发展的过程中重视对员工的业务培训，通过打造学习型组织，高认知团队，为客户与用户提供最好的产品
                    </div>
                  </div>
                  <div className='companyItem'>
                    <div className='title'>成就</div>
                    <div className='itemContent'>公司创立两年，已获得行业内多位专家的一致认可，并与国内多家大型三甲或专科医院建立合作</div>
                  </div>
                  <div className='companyItem'>
                    <div className='title'>目标</div>
                    <div className='itemContent'>嘉云升人将竭尽所能以创新力、设计力、科技力、人文力为行业赋能，为客户赋能，为用户赋能</div>
                  </div>
                </div>
                <div className='p-companyWrap'>
                  <div className='p-companyItem'>
                    <div className='title'>/ 团队 /</div>
                    <div className='itemContent'>嘉云升创始团队由具有丰富经验的医学科学家、产品专家、技术专家、数据专家组成。我们对医疗服务、企业级应用、互联网产业的整合具有独特的洞察与丰富的经验，我们在产品中使用最为前沿的科技以保障对医护工作、研究工作等专业人士在效率和交互体验等多方面的提升</div>
                  </div>
                  <div className='p-companyItem'>
                    <div className='title'>/ 专业 /</div>
                    <div className='itemContent'>医疗是一个进入壁垒高、知识门槛高的领域，我们在发展的过程中重视对员工的业务培训，通过打造学习型组织，高认知团队，为客户与用户提供最好的产品</div>
                  </div>
                  <div className='p-companyItem'>
                    <div className='title'>/ 成就 /</div>
                    <div className='itemContent'>公司创立两年，已获得行业内多位专家的一致认可，并与国内多家大型三甲或专科医院建立合作</div>
                  </div>
                  <div className='p-companyItem'>
                    <div className='title'>/ 目标 /</div>
                    <div className='itemContent'>嘉云升人将竭尽所能以创新力、设计力、科技力、人文力为行业赋能，为客户赋能，为用户赋能</div>
                  </div>
                </div>
              </div>

            </TabPane>
          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/CompanyIntro/index.js